import menuDashboard from "./dashboard_icon.png";
import dasboardIcon from "./dashboard.svg";
import menuExit from "./exitwhite.svg";
import menuUser from "./user_icon.png";
import helpIcon from "./help.svg";
import analytics from "./analytics.svg";
import arrowGreenUp from "./Polygon1.svg";
import moreInfo from "./threepoints.svg";
import userPurple from "./user_gray.svg";
import closeSessionPurple from "./close_Sesion.svg";
import helpPurple from "./helppurple.svg";
import arrowMwnuState from "./arrowmenustate.svg";
import loading from "./giphy.gif";
import dashboardBlue from "./dashboardblue.svg";
import closeBlue from "./closeBlue.svg";
import analiticsBlue from "./analitBlue.svg";
import table from "./users_white.svg";
import tableBlue from "./users_blue.svg";
import union from "./Union.svg";
import trashIcon from "./trash.svg";
import thasbalckicon from "./thrasblack.svg";
import helpWhite from "./help_white.svg"
import delete_blue from './delete_blue.svg'
import edite_blue from "./edit_blue.svg"
import perfil_blue from "./perfil_blue.svg"
import initialDate from "./initialDate.svg"
import endDate from "./endDate.svg"
import progress from "./progress.svg"
import pointsSheld from "./pointsSheld.svg"
import mayorqueicon from "./matorqueicon.svg"
import watch from "./watch.svg"
import shield from "./shield.svg"
import start from "./Star.png"
import dashboardRed from "./dashboard-red.svg"
import usersRed from "./users-red.svg"
import helpRed from "./Ayuda-red.svg"

import clock from "./colgate/Clock.svg"
import book from "./colgate/Book.svg"
import board from "./colgate/Board.svg"
import arrowRepeat from "./colgate/bi_arrow-repeat.svg"
import calendar from "./colgate/Calendar.svg"
import boardblack from "./colgate/Board_black.svg"
import bookblack from "./colgate/Book_black.svg"
import usersblack from "./colgate/Users_black.svg"


export const icons = {
    arrowRepeat,
    calendar,
    clock,
    book,
    board,
    boardblack,
    bookblack,
    usersblack,

    dashboardRed,
    usersRed,
    helpRed,
    initialDate,
    watch,
    start,
    shield,
    mayorqueicon,
    endDate,
    progress,
    pointsSheld,
    delete_blue,
    edite_blue,
    perfil_blue,
    helpWhite,
	loading,
	union,
	thasbalckicon,
	trashIcon,
	dasboardIcon,
	moreInfo,
	table,
	analytics,
	arrowGreenUp,
	helpIcon,
	menuDashboard,
	dashboardBlue,
	closeBlue,
	analiticsBlue,
	tableBlue,
	menuExit,
	menuUser,
	userPurple,
	closeSessionPurple,
	helpPurple,
	arrowMwnuState,
};
